import React, { useState, useEffect } from 'react';
import './nav.css';
import { BiHome } from 'react-icons/bi';
import { AiOutlineUser } from 'react-icons/ai';
import { BsBookHalf } from 'react-icons/bs';
import { RiServiceLine } from 'react-icons/ri';
import { BiMessageDetail } from 'react-icons/bi';
import { RiBriefcaseLine } from 'react-icons/ri';

function Nav() {
  const [activeNav, setActiveNav] = useState('#');

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY + window.innerHeight / 3;

      const sections = {
        '#': 0,
        '#about': document.getElementById('about')?.offsetTop ?? Infinity,
        '#experience': document.getElementById('experience')?.offsetTop ?? Infinity,
        '#services': document.getElementById('services')?.offsetTop ?? Infinity,
        '#portfolio': document.getElementById('portfolio')?.offsetTop ?? Infinity,
        '#contact': document.getElementById('contact')?.offsetTop ?? Infinity,
      };

      let activeSection = '#';
      const sectionIds = Object.keys(sections).reverse();
      for (const sectionId of sectionIds) {
        if (scrollY >= sections[sectionId]) {
          activeSection = sectionId;
          break;
        }
      }

      setActiveNav(activeSection);
    };

    handleScroll();

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <nav>
      <a href="#" className={activeNav === '#' ? 'active' : ''}>
        <BiHome />
      </a>
      <a href="#about" className={activeNav === '#about' ? 'active' : ''}>
        <AiOutlineUser />
      </a>
      <a href="#experience" className={activeNav === '#experience' ? 'active' : ''}>
        <BsBookHalf />
      </a>
      <a href="#portfolio" className={activeNav === '#portfolio' ? 'active' : ''}>
        <RiBriefcaseLine />
      </a>
      {/* Removed Services link */}
      {/* <a href="#services" className={activeNav === '#services' ? 'active' : ''}>
        <RiServiceLine />
      </a> */}
      <a href="#contact" className={activeNav === '#contact' ? 'active' : ''}>
        <BiMessageDetail />
      </a>
    </nav>
  );
}

export default Nav;
